module.exports = __webpack_public_path__ + "img/thumb-janie.9656ef81.png";